<template>
  <div class="backDiv">
    <div class="pageMenu">
      <el-tag class="pageTag">期次筛选：</el-tag>
      <el-select
        clearable
        v-model="queryPeriodParam.industryInfoId"
        placeholder="请选择从事行业"
        @change="industryInfoChange"
      >
        <el-option
          v-if="industryInfoList && industryInfoList.length > 0"
          v-for="item in industryInfoList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="queryPeriodParam.menTypeId"
        placeholder="请选择人员类别"
        @change="menTypeChange"
      >
        <el-option
          v-if="menTypeList && menTypeList.length > 0"
          v-for="item in menTypeList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="queryPeriodParam.periodTypeId"
        placeholder="请选择期次类型"
        @change="periodInfoListLoad"
      >
        <el-option
          v-if="periodTypeList && periodTypeList.length > 0"
          v-for="item in periodTypeList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="openQueryDialog(3)" icon="el-icon-printer"
        >往期档案打印</el-button
      >
      <el-button type="primary" @click="downLoadFile()" icon="el-icon-camera"
        >照片处理工具</el-button
      >
    </div>
    <div class="p-lr-20">
      <el-row>
        <el-col :span="14">
          <el-table
            ref="periodInfoTable"
            :data="periodInfoList"
            highlight-current-row
            @current-change="leftListClick"
            height="calc(100vh - 350px)"
            style="width: 100%"
            :default-sort="{ prop: 'SignUpEndDate', order: 'ascending' }"
          >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="Name" label="培训期次" sortable></el-table-column>
            <el-table-column
              prop="PeriodClass"
              label="取证类型"
              sortable
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="SignUpBegDate"
              label="报名开始日期"
              sortable
              width="140"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="SignUpEndDate"
              label="报名截止日期"
              sortable
              width="140"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="WantExamDate"
              label="考核日期"
              sortable
              width="140"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="IsFullStarffed"
              label="状态"
              width="80"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.IsSignUpEnd === true"
                  type="danger"
                  disable-transitions
                  >截止</el-tag
                >
                <el-tag
                  v-if="
                    scope.row.IsSignUpEnd === false && scope.row.IsFullStarffed === true
                  "
                  type="danger"
                  disable-transitions
                  >满员</el-tag
                >
                <el-tag
                  v-if="
                    scope.row.IsSignUpEnd === false && scope.row.IsFullStarffed === false
                  "
                  type="success"
                  disable-transitions
                  >正常</el-tag
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="10" class="p-20">
          <el-form :model="currentPeriodInfo" label-width="120px">
            <el-form-item label="培训期次">
              <el-input v-model="currentPeriodInfo.Name" readonly></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="取证类型">
                  <el-select v-model="currentPeriodInfo.PeriodClass" disabled>
                    <el-option label="初次领证" value="初次领证"></el-option>
                    <el-option label="延期换证" value="延期换证"></el-option>
                    <el-option label="继续教育" value="继续教育"></el-option>
                    <el-option label="复训" value="复训"></el-option>
                    <el-option label="年度培训" value="年度培训"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="期次状态">
                  <el-input
                    v-if="currentPeriodInfo.IsSignUpEnd === true"
                    value="截止"
                    readonly
                  ></el-input>
                  <el-input
                    v-if="
                      currentPeriodInfo.IsSignUpEnd === false &&
                      currentPeriodInfo.IsFullStarffed === true
                    "
                    value="满员"
                    readonly
                  ></el-input>
                  <el-input
                    v-if="
                      currentPeriodInfo.IsSignUpEnd === false &&
                      currentPeriodInfo.IsFullStarffed === false
                    "
                    value="正常"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报名日期">
                  <el-input
                    v-model="currentPeriodInfo.SignUpDateString"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="培训日期">
                  <el-input
                    v-model="currentPeriodInfo.TrainDateString"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="审核截止">
                  <el-input v-model="currentPeriodInfo.CheckEndDate" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="核发准考证">
                  <el-input v-model="currentPeriodInfo.PrintBookDate" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="考核日期">
                  <el-input v-model="currentPeriodInfo.WantExamDate" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="培训地点">
                  <el-input
                    v-model="currentPeriodInfo.Address"
                    :title="currentPeriodInfo.Address"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注信息">
                  <el-input v-model="currentPeriodInfo.BackMemo" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin-bottom: 20px; text-align: left; line-height: 46px">
            <el-button
              v-if="!currentPeriodInfo.IsFullStarffed && currentPeriodInfo.IsAbleSignUp"
              type="primary"
              :disabled="btnIsDisable"
              @click="openQueryDialog(4)"
              icon="el-icon-thumb"
              >在线报名
            </el-button>
            <el-button
              v-if="currentPeriodInfo.NoticeFileUrl"
              type="warning"
              @click="downLoadSignFile(currentPeriodInfo.NoticeFileUrl)"
              icon="el-icon-s-order"
              >报名须知</el-button
            >
            <el-button
              v-if="currentPeriodInfo.SignUpFileUrl"
              type="warning"
              @click="downLoadSignFile(currentPeriodInfo.SignUpFileUrl)"
              icon="el-icon-s-claim"
              >报名表格</el-button
            >
            <el-button
              v-if="currentPeriodInfo.IsAblePrintExamBook"
              type="primary"
              :disabled="btnIsDisable"
              @click="openQueryDialog(1)"
              icon="el-icon-printer"
              >准考证打印</el-button
            >
            <el-button
              type="success"
              :disabled="btnIsDisable"
              @click="openQueryDialog(2)"
              icon="el-icon-search"
            >
              报名结果查询</el-button
            >
            <el-button
              v-if="
                currentPeriodInfo.AttachFileSettingList &&
                currentPeriodInfo.AttachFileSettingList.length > 0
              "
              type="success"
              @click="isShowAttachSettingDialog = true"
              icon="el-icon-folder"
              >报名所需材料</el-button
            >
            <el-button
              v-if="currentPeriodInfo.ClassQrCodeImageUrl"
              type="success"
              @click="downLoadSignFile(currentPeriodInfo.ClassQrCodeImageUrl)"
              icon="el-icon-chat-line-round"
              >班级群二维码</el-button
            >
          </div>
          <el-alert
            title="提示：报名结果查询，需选中要查询的期次信息，再点击“报名结果查询”按钮"
            type="warning"
          ></el-alert>
        </el-col>
      </el-row>
    </div>

    <!--报名附件列表 begin-->
    <el-dialog
      :title="currentPeriodInfo.Name + ' - 报名所需材料'"
      :visible.sync="isShowAttachSettingDialog"
      width="1200px"
      append-to-body
    >
      <el-table
        :data="currentPeriodInfo.AttachFileSettingList"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column type="index" width="50" align="center"></el-table-column>
        <el-table-column prop="Name" width="240" label="附件名称"></el-table-column>
        <el-table-column
          prop="IsMust"
          label="附件要求"
          width="80"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.IsMust === true ? 'primary' : 'success'"
              disable-transitions
              >{{ scope.row.IsMust ? "必要的" : "可选的" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="IsOnly"
          label="附件数量"
          width="120"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.IsOnly === true ? 'primary' : 'success'"
              disable-transitions
              >{{ scope.row.IsOnly ? "一份" : "一份或多份" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="AllowSuffix"
          width="120"
          label="附件后缀"
        ></el-table-column>
        <el-table-column prop="Describe" label="描述信息"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="isShowAttachSettingDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--报名附件列表 end-->

    <!--在线报名表单 begin-->
    <el-dialog
      :title="'在线报名 - ' + currentPeriodInfo.Name"
      :visible.sync="isShowSignUpDialog"
      top="6vh"
      width="1400px"
      @close="closeSignUpDialog"
      :modal-append-to-body="false"
    >
      <sign-up @colseParentSignUpDialog="closeSignUpDialog" ref="signupCompose"></sign-up>
      <span slot="footer">
        <el-button type="primary" @click="submitSignUpForm">确认提交</el-button>
        <el-button type="warning" @click="resetSignUpForm">重 置</el-button>
        <el-button @click="closeSignUpDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!--在线报名表单 end-->

    <!--报名查询表单 begin-->
    <el-dialog
      :title="
        dialogShowTitle +
        (dialogShowTitle.indexOf(' - ') == -1 ? '' : currentPeriodInfo.Name)
      "
      :visible.sync="isShowQueryDialog"
      width="400px"
      @close="closeQueryDialog"
    >
      <el-alert
        title="请正确输入您报名时填写的身份证号信息。"
        type="warning"
        show-icon
        style="margin-bottom: 30px"
        v-if="dialogShowTitle != '在线报名 - '"
      ></el-alert>
      <el-form ref="queryForm" :model="querySignUpData" :rules="rules" label-width="80px">
        <el-form-item label="身份证号" prop="IDCard">
          <el-input v-model="querySignUpData.IDCard"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="CheckNum">
          <el-input
            v-model="querySignUpData.CheckNum"
            style="width: 50%"
            @keyup.enter.native="submitQueryData"
          >
          </el-input>
          <img
            @click="getCodeImage"
            style="float: right; margin-top: 5px; cursor: pointer"
            :src="codeImageUrl"
            alt
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="submitQueryData">确 定</el-button>
        <el-button @click="closeQueryDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!--报名查询表单 end-->

    <!--查询结果表单 begin-->
    <el-dialog
      :title="'查询结果 - ' + currentPeriodInfo.Name"
      :visible.sync="isShowQueryResultDialog"
      top="6vh"
      width="1400px"
      @close="closeQueryResultDialog"
      :modal-append-to-body="false"
    >
      <query-result
        @colseParentSignUpDialog="closeQueryResultDialog"
        ref="queryResultCompose"
      ></query-result>
      <span v-if="isShowQueryResultBtns" slot="footer">
        <el-button type="primary" @click="submitSignUpEditForm">确认提交</el-button>
        <el-button @click="closeQueryResultDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!--查询结果表单 end-->

    <!--查询打印列表结果 begin-->
    <el-dialog
      title="往期档案打印"
      :visible.sync="isShowQueryPrintDataDialog"
      top="7vh"
      width="1200px"
    >
      <el-table :data="queryPrintSignUpDataList" stripe style="width: 100%" height="70vh">
        <el-table-column prop="PeriodInfoName" label="期次名称"> </el-table-column>
        <el-table-column prop="CreateDate" label="报名时间" width="210">
        </el-table-column>
        <el-table-column prop="PeriodClass" label="取证类型" width="140">
        </el-table-column>
        <el-table-column prop="ExamResultString" label="考核结果" width="140">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.ExamResultString === '未通过' ? 'danger' : 'success'"
              disable-transitions
              >{{ scope.row.ExamResultString }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleBtnPrint(scope.row, 1)"
              >打印培训档案</el-button
            >
            <el-button size="mini" type="primary" @click="handleBtnPrint(scope.row, 2)"
              >打印学时证明</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--查询打印列表结果 end-->
  </div>
</template>

<script>
import {
  getToken,
  getIndustryInfoList,
  getMenTypeList,
  getPeriodTypeList,
  getPeriodInfoList,
  querySignUpStatus,
  queryPrintTrainDataByIDCard,
  queryPrintTrainDocById,
  queryPrintProveById,
  queryFrontSignUpInfo,
} from "../api/index.js";
import signUp from "./SignUp.vue";
import queryResult from "./QueryResult.vue";
export default {
  name: "Index",
  components: { signUp, queryResult },
  data() {
    return {
      queryPeriodParam: {
        industryInfoId: "",
        menTypeId: "",
        periodTypeId: "",
        routeKey: "",
        isShowAll: true,
      },
      industryInfoList: [],
      menTypeList: [],
      periodTypeList: [],
      periodInfoList: [],
      codeImageUrl: "",
      currentPeriodInfo: {},
      querySignUpData: {
        PeriodInfoId: "",
        IDCard: "",
        CheckNum: "",
        CheckNumToken: "",
        IsPrintExamBook: false,
      },
      //查询打印相关的报名信息
      queryPrintSignUpData: {
        RouteKey: "",
        IDCard: "",
        CheckNum: "",
        CheckNumToken: "",
      },
      //查询报名信息打印信息
      queryPrintDetailData: {
        SignUpInfoId: "",
        CheckNum: "",
        CheckNumToken: "",
      },
      btnIsDisable: false,
      isShowSignUpDialog: false,
      isShowQueryDialog: false,
      isShowQueryResultDialog: false,
      isShowAttachSettingDialog: false,
      isShowQueryResultBtns: false,
      rules: {
        IDCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            min: 18,
            max: 18,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
        ],
        CheckNum: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "请输入正确的验证码", trigger: "blur" },
        ],
      },
      showDefaultImage: "https://cr.apmem.com/Content/imgForPage/jzzy_small.jpg",
      showPayImage: ["https://cr.apmem.com/Content/imgForPage/jzzy.jpg"],
      dialogShowTitle: "报名结果查询 - ",
      queryPrintSignUpDataList: [], //查询打印报名结果列表信息
      isShowQueryPrintDataDialog: false, //是否打开查询打印列表信息
    };
  },
  methods: {
    //获取验证码
    getCodeImage() {
      let _this = this;
      getToken()
        .then((res) => {
          if (res.state == "success") {
            _this.querySignUpData.CheckNumToken = res.data;
            _this.queryPrintSignUpData.CheckNumToken = res.data;
            _this.queryPrintDetailData.CheckNumToken = res.data;
            _this.codeImageUrl =
              "https://cr.apmem.com/App/GetAuthCode?token=" +
              _this.querySignUpData.CheckNumToken;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //从事行业列表加载
    industryInfoListLoad() {
      let _this = this;
      _this.industryInfoList = [];
      getIndustryInfoList()
        .then((res) => {
          if (res.state == "success") {
            _this.industryInfoList = res.data;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //人员类别切换点击事件
    industryInfoChange() {
      this.menTypeListLoad();
      this.periodTypeListLoad();
      this.periodInfoListLoad();
    },
    //人员类别列表加载
    menTypeListLoad() {
      let _this = this;
      _this.menTypeList = [];
      _this.queryPeriodParam.menTypeId = "";
      let queryParam = {
        industryInfoId: _this.queryPeriodParam.industryInfoId,
      };
      getMenTypeList(queryParam)
        .then((res) => {
          if (res.state == "success") {
            _this.menTypeList = res.data;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //人员类别切换点击事件
    menTypeChange() {
      //console.log(this.queryPeriodParam.menTypeId);
      this.periodTypeListLoad();
      this.periodInfoListLoad();
    },
    //期次类型列表加载
    periodTypeListLoad() {
      let _this = this;
      _this.periodTypeList = [];
      _this.queryPeriodParam.periodTypeId = "";
      if (_this.queryPeriodParam.menTypeId) {
        let queryParam = {
          menTypeId: _this.queryPeriodParam.menTypeId,
          routeKey: _this.queryPeriodParam.routeKey,
        };
        getPeriodTypeList(queryParam)
          .then((res) => {
            if (res.state == "success") {
              if (res.data && res.data.length > 0) {
                _this.periodTypeList = res.data;
              }
            } else {
              _this.$message.error(res.message);
            }
          })
          .catch((error) => {
            _this.$message.error("网络连接失败，请稍后重试");
          });
      }
    },
    //培训期次列表加载
    periodInfoListLoad() {
      let _this = this;
      getPeriodInfoList(this.queryPeriodParam)
        .then((res) => {
          if (res.state == "success") {
            _this.periodInfoList = JSON.parse(res.data);
            if (_this.periodInfoList.length == 0) {
              _this.currentPeriodInfo = {};
              _this.btnIsDisable = true;
              _this.$message.warning("暂无培训安排");
            } else {
              //默认选中第一条数据
              _this.btnIsDisable = false;
              _this.$refs.periodInfoTable.setCurrentRow(_this.periodInfoList[0]);
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //左侧列表单击事件
    leftListClick(val) {
      if (val && val.Id) {
        this.currentPeriodInfo = val;
        this.querySignUpData.PeriodInfoId = val.Id;
        localStorage.setItem("currentPeriodInfo", JSON.stringify(val));
      } else {
        this.currentPeriodInfo = {};
        this.querySignUpData.PeriodInfoId = "";
        localStorage.setItem("currentPeriodInfo", "");
      }
      if (this.$refs.signupCompose) {
        //重置报名信息表单
        this.$refs.signupCompose.cleanData();
      }
    },
    //打开报名对话框
    openSignUpDialog() {
      this.isShowSignUpDialog = true;
      let _this = this;
      setTimeout(() => {
        _this.$refs.signupCompose.changePeriodInfo();
      }, 2000);
    },
    //重置报名对话框
    resetSignUpForm() {
      this.$refs.signupCompose.cleanData();
    },
    //提交报名对话框
    submitSignUpForm() {
      this.$refs.signupCompose.submiteSignUp();
    },
    //提交报名查询对话框
    submitSignUpEditForm() {
      this.$refs.queryResultCompose.submiteSignUp();
    },
    //关闭报名对话框
    closeSignUpDialog() {
      this.isShowSignUpDialog = false;
    },
    //打开查询对话框
    openQueryDialog(printType) {
      this.cleanQueryData();
      this.isShowQueryDialog = true;
      if (printType == 1) {
        this.dialogShowTitle = "准考证打印 - ";
        this.querySignUpData.IsPrintExamBook = true;
      } else if (printType == 2) {
        this.dialogShowTitle = "报名结果查询 - ";
        this.querySignUpData.IsPrintExamBook = false;
      } else if (printType == 3) {
        this.dialogShowTitle = "往期档案打印（三年内）";
      } else if (printType == 4) {
        this.dialogShowTitle = "在线报名 - ";
      }
    },
    //关闭查询对话框
    closeQueryDialog() {
      this.isShowQueryDialog = false;
    },
    //关闭结果对话框
    closeQueryResultDialog() {
      this.isShowQueryResultDialog = false;
    },
    //重置查询参数
    cleanQueryData() {
      this.querySignUpData.IDCard = "";
      this.querySignUpData.CheckNum = "";
      this.queryPrintSignUpData.IDCard = "";
      this.queryPrintSignUpData.CheckNum = "";
      this.queryPrintDetailData.IDCard = "";
      this.queryPrintDetailData.CheckNum = "";
      this.getCodeImage();
    },
    //提交报名信息查询
    submitQueryData() {
      let _this = this;
      this.isShowQueryResultBtns = false;
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          if (_this.dialogShowTitle.indexOf("-") == -1) {
            //证书打印相关
            _this.queryPrintSignUpData.RouteKey = _this.queryPeriodParam.routeKey;
            _this.queryPrintSignUpData.IDCard = _this.querySignUpData.IDCard;
            _this.queryPrintSignUpData.CheckNum = _this.querySignUpData.CheckNum;
            queryPrintTrainDataByIDCard(_this.queryPrintSignUpData)
              .then((res) => {
                _this.cleanQueryData();
                //console.log(res);
                if (res.state == "success") {
                  //关闭查询窗口
                  _this.isShowQueryDialog = false;
                  if (res.data.length == 0) {
                    _this.$message.error("未查询到您的往期档案信息");
                  } else {
                    _this.queryPrintSignUpDataList = res.data;
                    //打开打印查询结果列表弹窗
                    _this.isShowQueryPrintDataDialog = true;
                  }
                } else {
                  _this.$message.error(res.message);
                }
              })
              .catch((error) => {
                _this.querySignUpData.CheckNum = "";
                _this.getCodeImage();
                _this.$message.error("网络连接失败，请稍后重试");
              });
          } else if (this.dialogShowTitle == "在线报名 - ") {
            //查询学员历史报名记录回填报名基础信息
            let requestModel = {
              RouteKey: _this.queryPeriodParam.routeKey,
              IDCard: _this.querySignUpData.IDCard,
              CheckNum: _this.querySignUpData.CheckNum,
              CheckNumToken: _this.querySignUpData.CheckNumToken,
            };
            localStorage.removeItem("querySignUpHistoryData");
            queryFrontSignUpInfo(requestModel)
              .then((res) => {
                let idcard = _this.querySignUpData.IDCard;
                _this.isShowQueryDialog = false;
                _this.cleanQueryData();
                //console.log(res);
                if (res.state == "success") {
                  //赋值报名历史记录信息
                  localStorage.setItem(
                    "querySignUpHistoryData",
                    JSON.stringify(res.data)
                  );
                } else {
                  let idcardModel = {
                    IsPersonal: false,
                    IndustryInfoId: "",
                    PeriodInfoId: "",
                    AreaInfoId: "",
                    CompanyGroupId: "",
                    MenTypeId: "",
                    MenTypeName: "",
                    Name: "",
                    Sex: "",
                    IDCard: idcard,
                    MobilePhone: "",
                    EduLevel: "",
                    EduSkill: "",
                    School: "",
                    FinishDateString: "",
                    WorkSite: "",
                    AboutTitle: "",
                    SkillLevel: "",
                    WorkYear: 0,
                    WorkTypeId: "",
                    WorkTypeName: "",
                    WorkTypeCustomName: "",
                    DutyFromString: "",
                    LicensePlate: "",
                    PostalAddress: "",
                    MailAddress: "",
                    WorkHistory: "",
                    BillType: "",
                    BillDetail: "单位名称：\r\n纳税人识别号：",
                    BackMemo: "",
                    FirstBookDateString: "",
                    CheckNum: "",
                    CheckNumToken: "",
                  };
                  localStorage.setItem(
                    "querySignUpHistoryData",
                    JSON.stringify(idcardModel)
                  );
                }
                setTimeout(() => {
                  //打开报名弹窗
                  _this.openSignUpDialog();
                  if (_this.$refs.signupCompose) {
                    _this.$refs.signupCompose.bindPageData();
                  }
                }, 1000);
              })
              .catch((error) => {
                _this.querySignUpData.CheckNum = "";
                _this.getCodeImage();
                _this.$message.error("网络连接失败，请稍后重试");
              });
          } else {
            //报名信息查询相关
            querySignUpStatus(_this.querySignUpData)
              .then((res) => {
                _this.cleanQueryData();
                //console.log(res);
                if (res.state == "success") {
                  _this.isShowQueryDialog = false;
                  if (_this.querySignUpData.IsPrintExamBook) {
                    let queryData = res.data;
                    if (queryData.CheckResult != 5) {
                      _this.$message.error("请确认您的资格审查状态");
                    } else if (queryData.ExamOrder < 1) {
                      _this.$message.error("请耐心等待管理员考场安排");
                    } else {
                      localStorage.setItem("printResultData", JSON.stringify(res.data));
                      const { href } = _this.$router.resolve({
                        name: "ExamBook",
                      });
                      window.open(href, "_blank");
                    }
                  } else {
                    localStorage.setItem("queryResultData", JSON.stringify(res.data));
                    if (res.data.CheckResult == 2) {
                      _this.isShowQueryResultBtns = true;
                    }
                    if (_this.$refs.queryResultCompose) {
                      _this.$refs.queryResultCompose.bindPageData();
                    }
                    _this.isShowQueryResultDialog = true;
                  }
                } else {
                  _this.$message.error(res.message);
                }
              })
              .catch((error) => {
                _this.querySignUpData.CheckNum = "";
                _this.getCodeImage();
                _this.$message.error("网络连接失败，请稍后重试");
              });
          }
        } else {
          return false;
        }
      });
    },
    //点击查询
    handleBtnPrint(row, printType) {
      //console.log(row, printType);
      let _this = this;
      if (printType == 1) {
        //培训档案
        let queryParamModel = {
          signUpInfoId: row.Id,
        };
        queryPrintTrainDocById(queryParamModel)
          .then((res) => {
            //console.log(res);
            if (res.state == "success") {
              localStorage.setItem("printTrainDocCacheData", JSON.stringify(res.data));
              const { href } = _this.$router.resolve({
                name: "PrintTrainDoc",
              });
              window.open(href, "_blank");
            } else {
              _this.$message.error(res.message);
            }
          })
          .catch((error) => {
            _this.querySignUpData.CheckNum = "";
            _this.getCodeImage();
            _this.$message.error("网络连接失败，请稍后重试");
          });
      } else {
        //学时证明
        let queryParamModel = {
          signUpInfoId: row.Id,
        };
        queryPrintProveById(queryParamModel)
          .then((res) => {
            //console.log(res);
            if (res.state == "success") {
              localStorage.setItem("printProveCacheData", JSON.stringify(res.data));
              const { href } = _this.$router.resolve({
                name: "PrintProve",
              });
              window.open(href, "_blank");
            } else {
              _this.$message.error(res.message);
            }
          })
          .catch((error) => {
            _this.querySignUpData.CheckNum = "";
            _this.getCodeImage();
            _this.$message.error("网络连接失败，请稍后重试");
          });
      }
    },
    //报名表格下载
    downLoadSignFile(fileUrl) {
      window.open("https://cr.apmem.com" + fileUrl);
    },
    //照片处理工具下载
    downLoadFile() {
      let url = "../static/PhotoDeal.rar";
      const a = document.createElement("a");
      a.href = url;
      a.download = "PhotoDeal.rar"; // 下载后文件名
      a.style.display = "none";
      document.body.appendChild(a);
      a.click(); // 点击下载
      document.body.removeChild(a); // 下载完成移除元素
    },
  },
  activated() {
    let routeKey = "";
    let currentDomain = window.location.hostname;
    //根据域名判断rk值
    if (currentDomain.indexOf("sypxzx") > -1) {
      routeKey = "syyp";
      //写入缓存中
      sessionStorage.setItem("routeKey", routeKey);
    } else {
      //查询url中的单位编号信息
      routeKey = this.$route.query.rk;
      if (routeKey) {
        //写入缓存中
        sessionStorage.setItem("routeKey", routeKey);
      } else {
        //查询缓存中
        routeKey = sessionStorage.getItem("routeKey");
      }
    }
    this.queryPeriodParam.routeKey = routeKey;
    //判断路由参数赋值系统名称
    switch (routeKey) {
      case "lf":
        document.title = "临汾市在线报名管理系统";
        break;
      case "jzzy":
        document.title = "晋中职院在线报名管理系统";
        //提示疫情信息弹窗
        // this.$confirm('根据最新工作要求，学院原定培训班延期举办，具体开班时间另行通知；给大家带来的不便敬请谅解。', '培训暂缓通知', {
        //   confirmButtonText: '确定',
        //   showCancelButton: false
        // }).then(() => { });
        break;
      case "syyp":
        document.title = "寿阳县应急管理事务服务中心在线报名管理系统";
        break;
      default:
        break;
    }
    //加载期次信息列表
    this.periodInfoListLoad();
    //加载从事行业列表
    this.industryInfoListLoad();
  },
};
</script>
<style scoped>
.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px;
}

.backDiv {
  background-color: #fff;
  padding: 0px;
  text-align: left;
}

.pageMenu {
  background-color: rgb(84, 92, 100);
  height: 40px;
  padding: 10px 20px;
  vertical-align: middle;
}

.pageTag {
  height: 40px;
  padding: 4px 10px;
  font-size: 14px;
}

.p-lr-20 {
  padding: 0px 20px;
}

.p-20 {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue